import { get } from 'lodash-es';

/**
 * @description: a generic spendLevel filter that returns the numeric value
 * associated with the fieldName property in a spendLevel object e.g. plannedSpendLevel, targetSpendLevel
 * @example targetSpendLevel | spendBySpendLevelFieldName
 * @param: spendLevel object from service - several services implement this object
 * @return number
 */
export default function SpendBySpendLevelFieldName() {
  // currently only works for targetSpendLevel object - see warning note above
  return (spendLevel: any = {}): number => {
    // not exactly sure why fieldNames is an array
    const fieldName =
      get(spendLevel, 'type.fieldNames[0]', '') ||
      get(spendLevel, 'spendLevelType.fieldNames[0]', '');

    return spendLevel[fieldName];
  };
}
